var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registerBox"},[_c('div',{staticClass:"btnArea"},[_c('YellowButton',{attrs:{"label":_vm.button_label},on:{"click":_vm.go_click}})],1),_c('div',{staticClass:"textbox"},[_vm._t("template")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }